import React from 'react';
import { SideBarItems } from 'components/Sidebar';
import { Settings } from 'modules/Infralytiqs/Settings';
import { Reports } from 'modules/Infralytiqs/Reports';
import { Logs } from 'modules/Infralytiqs/Logs';
import { AuditLogs } from 'modules/Infralytiqs/AuditLogs';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import AssessmentOutlined from '@mui/icons-material/AssessmentOutlined';
import ListAltOutlined from '@mui/icons-material/ListAltOutlined';
import HistoryOutlined from '@mui/icons-material/HistoryOutlined';
import { InfralytiqsSidebarIcon } from './InfralytiqsSidebarIcon';

const buildInfralytiqsItems = (menuKey: 'instantUpdate' | 'infralytiqs'): SideBarItems[] => [{
    path: "/",
    urlKey: "infralytiqs",
    text: "Infralytiqs",
    icon: <InfralytiqsSidebarIcon />,
    type: "menuHeader",
    menuKey,
    requiredModule: "infralytiqs.com",
    dictionaryKey: "sidebar-menu-infralytiqs",
    items: [
        {
            path: "/infralytiqs/",
            urlKey: "settings",
            text: "Settings",
            icon: <SettingsOutlined />,
            type: "menuItem",
            menuKey,
            module: <Settings />,
            dictionaryKey: "sidebar-menu-infralytiqs-settings",
            requiredModule: "infralytiqs.com",
            requiredRole: "admin",
        },
        {
            path: "/infralytiqs/",
            urlKey: "reports",
            text: "Reports",
            icon: <AssessmentOutlined />,
            type: "menuItem",
            menuKey,
            module: <Reports />,
            dictionaryKey: "sidebar-menu-infralytiqs-reports",
        },
        {
            path: "/infralytiqs/",
            urlKey: "logs",
            text: "Logs",
            icon: <ListAltOutlined />,
            type: "menuItem",
            menuKey,
            module: <Logs />,
            dictionaryKey: "sidebar-menu-infralytiqs-logs",
        },
        {
            path: "/infralytiqs/",
            urlKey: "audit-logs",
            text: "Audit Logs",
            icon: <HistoryOutlined />,
            type: "menuItem",
            menuKey,
            module: <AuditLogs />,
            dictionaryKey: "sidebar-menu-infralytiqs-audit-logs",
            requiredModule: "infralytiqs.com",
            requiredRole: "admin",
        },
    ]
}];

export const ModulesMenu: SideBarItems[] = [
    ...buildInfralytiqsItems('instantUpdate'),
    ...buildInfralytiqsItems('infralytiqs'),
    // Analytics branding for Campaign King domain
    {
        path: "/",
        urlKey: "analytics",
        text: "Analytics",
        icon: <InfralytiqsSidebarIcon />,
        type: "menuHeader",
        menuKey: "campaignKing",
        requiredModule: "infralytiqs.com",
        dictionaryKey: "sidebar-menu-analytics",
        items: [
            {
                path: "/analytics/",
                urlKey: "settings",
                text: "Settings",
                icon: <SettingsOutlined />,
                type: "menuItem",
                menuKey: "campaignKing",
                module: <Settings />,
                dictionaryKey: "sidebar-menu-analytics-settings",
                requiredModule: "infralytiqs.com",
                requiredRole: "admin",
            },
            {
                path: "/analytics/",
                urlKey: "reports",
                text: "Reports",
                icon: <AssessmentOutlined />,
                type: "menuItem",
                menuKey: "campaignKing",
                module: <Reports />,
                dictionaryKey: "sidebar-menu-analytics-reports",
            },
            {
                path: "/analytics/",
                urlKey: "audit-logs",
                text: "Audit Logs",
                icon: <HistoryOutlined />,
                type: "menuItem",
                menuKey: "campaignKing",
                module: <AuditLogs />,
                dictionaryKey: "sidebar-menu-analytics-audit-logs",
                requiredModule: "infralytiqs.com",
                requiredRole: "admin",
            },
        ]
    }
];
